import { Link } from 'react-router';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import axios from 'axios';



import RugbyHeader from '../components/header/rugby-header';

import './rugby-teams.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';



const srcpath = 'https://familyrugby.com/yt.json'



function RugbyTeams() {
    const [articles, setArticles] = useState([]);
    const [randomPlayer, setRandomPlayer] = useState(null);

    useEffect(() => {
        const fetchPlayers = async () => {
            try {
                const response = await axios.get(srcpath);
                const players = response.data.rugbyplayerscard;
                setArticles(players);

                if (players && players.length > 0) {
                    // Загружаем сохранённые данные
                    const savedData = JSON.parse(localStorage.getItem('randomPlayerData'));

                    // Текущее время
                    const now = new Date();

                    // Определяем Ташкентское время (UTC+5)
                    const tashkentOffset = 5 * 60; // +5 часов в минутах
                    const localOffset = now.getTimezoneOffset(); // разница с UTC
                    const tashkentTime = new Date(now.getTime() + (tashkentOffset + localOffset) * 60 * 1000);

                    // Получаем "сегодня" в Ташкенте (обнуляем часы)
                    const tashkentToday = new Date(tashkentTime);
                    tashkentToday.setHours(0, 0, 0, 0);

                    // Проверяем, не сохранён ли игрок на этот день
                    if (savedData && savedData.date === tashkentToday.toDateString()) {
                        setRandomPlayer(savedData.player);
                    } else {
                        // Выбираем нового игрока
                        const randomIndex = Math.floor(Math.random() * players.length);
                        const selectedPlayer = players[randomIndex];

                        // Сохраняем нового игрока и дату (по Ташкенту)
                        localStorage.setItem(
                            'randomPlayerData',
                            JSON.stringify({
                                player: selectedPlayer,
                                date: tashkentToday.toDateString(),
                            })
                        );

                        setRandomPlayer(selectedPlayer);
                    }
                }
            } catch (error) {
                console.error("Ошибка при загрузке JSON:", error);
            }
        };

        fetchPlayers();
    }, []);


    return (
        <>
            <RugbyHeader />
            <div className="teams">
                <div className='teams__hero'>
                    <div className="container teams-container">
                        <div className='teams__hero_title'>OUR TEAM</div>
                        {/* <div className='teams__hero_subtitle'>About & Players</div> */}
                    </div>
                </div>

                <div className="container teams-container">
                    <div className='teams__about'>
                        <div className='teams__about_title'>About</div>
                        <div className='teams__about_box'>
                            <div className='teams__about_slider'>
                                <Swiper
                                    autoplay={{
                                        delay: 10000,
                                        disableOnInteraction: false,
                                    }} pagination={{
                                        clickable: true,
                                    }}
                                    navigation={true} modules={[Autoplay, Pagination, Navigation]}
                                    className="mySwiper">
                                    <SwiperSlide><img src="/img/rugby.JPG" alt='OurTeam' /></SwiperSlide>
                                    <SwiperSlide><img src="/img/rugby.JPG" alt='OurTeam' /></SwiperSlide>
                                    <SwiperSlide><img src="/img/rugby.JPG" alt='OurTeam' /></SwiperSlide>
                                    <SwiperSlide><img src="/img/rugby.JPG" alt='OurTeam' /></SwiperSlide>
                                    <SwiperSlide><img src="/img/rugby.JPG" alt='OurTeam' /></SwiperSlide>
                                </Swiper>
                            </div>
                            <div className='teams__about_descr'>
                                The All Blacks are the most successful international men’s rugby team of all time — boasting a historic win rate of over 76% across hundreds of Test matches. Their impact on the global stage goes beyond silverware: they’ve set the benchmark for performance, humility, and team culture for over a century.
                                <br />
                                <br />
                                The All Blacks are the most successful international men’s rugby team of all time — boasting a historic win rate of over 76% across hundreds of Test matches. Their impact on the global stage goes beyond silverware: they’ve set the benchmark for performance, humility, and team culture for over a century.stage goes beyond silverware: they’ve set the benchmark for performance, humility, and team culture for over a century.
                            </div>
                        </div>
                    </div>

                    <div className='teams__stats'>
                        <div className='teams__stats_title'>Team Stats</div>


                    </div>

                    {randomPlayer && (
                        <div className='teams__featured'>
                            <div className='teams__featured_title'>Player of the Day</div>
                            <div className='teams__featured_box'>
                                <div className='teams__featured_img'>
                                    <img src={randomPlayer.imgsrc} alt={randomPlayer.name} />
                                </div>
                                <div className='teams__featured_info'>
                                    <div className='teams__featured_name'>{randomPlayer.name}</div>
                                    <div className='teams__featured_descr'>{randomPlayer.descr}</div>
                                    <Link to={`/${randomPlayer.playersrc}`} className='teams__featured_link'>
                                        More about {randomPlayer.name}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )}


                    <div className='teams__players'>
                        <div className='teams__players_title'>Our players</div>
                        <div className='teams__players_box'>
                            {articles.map((article, index) => {
                                return (
                                    <div key={index} className='teams__players_card'>
                                        <div className='teams__players_card-img'><img src={article.imgsrc} alt="Player Profile" /></div>
                                        <div className='teams__players_card-title'>{article.name}</div>
                                        <div className='teams__players_card-descr'>{article.descr}</div>
                                        <Link to={`/${article.playersrc}`} className='teams__players_card-link'>More</Link>
                                    </div>
                                );
                            })}
                        </div>
                    </div>


                </div>
            </div>

        </>
    );

}


export default RugbyTeams;